import React from 'react';
import './Programs.css';

const Programs = () => {
  const programs = [
    {
      title: 'Grade I - V',
      description: 'Foundation building with focus on core concepts and learning fundamentals',
      features: ['Interactive learning methods', 'Activity-based teaching', 'Strong foundation development', 'Regular assessments']
    },
    {
      title: 'Grade VI - VIII',
      description: 'Middle school excellence with comprehensive subject coverage',
      features: ['Conceptual clarity focus', 'Advanced problem-solving', 'Competitive exam preparation', 'Project-based learning']
    },
    {
      title: 'Grade IX - X',
      description: 'Board exam preparation with intensive coaching and practice',
      features: ['Board-specific curriculum', 'Mock tests and assessments', 'Time management strategies', 'Exam-focused approach']
    },
    {
      title: 'Grade XI - XII',
      description: 'Advanced learning with entrance exam guidance',
      features: ['Stream-specific coaching', 'Career counseling', 'Entrance exam preparation', 'Higher education guidance']
    }
  ];

  return (
    <section id="programs">
      <div className="section-header">
        <h2 className="section-title">Our Programs</h2>
        <p className="section-subtitle">
          Comprehensive education for all standards and boards
        </p>
      </div>
      <div className="programs-grid">
        {programs.map((program, index) => (
          <div key={index} className="program-card">
            <h3 className="program-title">{program.title}</h3>
            <p>{program.description}</p>
            <ul className="program-list">
              {program.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Programs;
